/*********************** Custom JS for Boost AI Search & Discovery  ************************/
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        let filterProducts = [];
        componentRegistry.useModulePlugin("FilterAPI", {
            name: "Store product list after fetching",
            apply(builder) {
                builder.on("methodFulfilled", "get", (payload) => {
                    filterProducts = payload.result.products;
                    return payload;
                });
                builder.on('beforeMethodCall', 'get', (payload) => {
                    try {
                        const countryCode = Shopify.country;
                        const currency = Shopify.currency.active;
                        const currencyRate = Shopify.currency.rate;
                        payload.args[0].country = countryCode
                        payload.args[0].currency = currency
                        payload.args[0].currency_rate = currencyRate
                    } catch (error) {
                        console.log(error)
                    }
                });
            },
        });
        componentRegistry.useModulePlugin('SearchAPI', {
            name: 'ensure params',
            apply(builder) {
                builder.on('beforeMethodCall', 'searchInCollection', (payload) => {
                    try {
                        const countryCode = Shopify.country;
                        const currency = Shopify.currency.active;
                        const currencyRate = Shopify.currency.rate;
                        payload.args[0].country = countryCode
                        payload.args[0].currency = currency
                        payload.args[0].currency_rate = currencyRate
                    } catch (error) {
                        console.log(error)
                    }
                });
                builder.on('beforeMethodCall', 'get', (payload) => {
                    if (!payload.args[2]) {
                        payload.args[2] = {};
                    }
                    // console.log('bhahfdhfds')
                    try {
                        const countryCode = Shopify.country;
                        const currency = Shopify.currency.active;
                        const currencyRate = Shopify.currency.rate;
                        payload.args[2].country = countryCode
                        payload.args[2].currency = currency
                        payload.args[2].currency_rate = currencyRate
                    } catch (error) {
                        console.log(error)
                    }
                });
            },
        });
        componentRegistry.useModulePlugin('CartAPI', {
            name: 'Integrate theme cart - #228698',
            apply(builder) {
                const cartAPI = BoostSDComponentRegistry.modules.CartAPI;
                cartAPI.__original.addToCart = async (id, quantity) => {
                    // You can modify body of the function
                    const product = filterProducts.find((product) => {
                        if (product.id === id) return true;
                        if (product.variants) {
                            return product.variants.find(variant => variant.id === id);
                        }
                        return false;
                    });
                    let productMetafields = product.metafields;
                    let dataVariantColor = null;
                    let dataVariantMetafield = productMetafields.find((item) => {
                        if (item.namespace === "color" && item.type === "single_line_text_field") {
                            return true;
                        }
                        return false;
                    });
                    if (dataVariantMetafield) {
                        dataVariantColor = dataVariantMetafield.value;
                    }
                    const payload = {
                        items: [{
                            id,
                            quantity,
                            properties: {
                                'Color': dataVariantColor
                            }
                        }, ],
                    };
                    return await fetch("/cart/add.js", {
                        method: "POST",
                        body: JSON.stringify(payload),
                        headers: {
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest",
                        },
                    });
                };
                builder.on('methodFulfilled', 'addToCart', async (payload) => {
                    jQuery('.cartcart').trigger('refresh');
                    jQuery('.cartcart.cart-modal').addClass('in');
                    jQuery.getJSON('/cart.js', function(cart) {
                        var cartItemCounter = cart.item_count;
                        jQuery('[data-cart-count]').html(cartItemCounter);
                        jQuery('[data-cart-count]').removeClass("hidden-count");
                    });
                    return payload;
                });
            },
        });
    }
]);
const customize = {
    updateProductItemGrid: (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductItem', {
            name: 'Add extra information',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    try {
                        // Start customization--------------------------------------------
                        let productData = element.getParams().props.product;
                        let productId = productData.id;
                        if (productData?.split_product) {
                            productId = productData.variant_id;
                        }
                        // let productItem = document.querySelector('[data-product-id="' + productId + '"]');
                        // const color = productData.metafields.find(e => e.key == "name" && e.namespace == "color");
                        // if (productItem) {
                        //     if (typeof color != 'undefined') {
                        //         const extraInfo = document.createElement("div");
                        //         extraInfo.classList.add('boost-sd-extra-info');
                        //         extraInfo.innerHTML = color.value;
                        //         if (!productItem.querySelector('.boost-sd-extra-info')) {
                        //             productItem.querySelector('.boost-sd__product-title').after(extraInfo);
                        //         }
                        //     }
                        // }
                        let productItems = document.querySelectorAll('.boost-sd__product-item[data-product-id="' + productId + '"]');
                        const color = productData.metafields.find(e => e.key == "name" && e.namespace == "color");
                        if (productItems) {
                            productItems.forEach((productItem) => {
                                console.log(productData.title, productItem, color)
                                if (typeof color != 'undefined') {
                                    const extraInfo = document.createElement("div");
                                    extraInfo.classList.add('boost-sd-extra-info');
                                    extraInfo.innerHTML = color.value;
                                    if (!productItem.querySelector('.boost-sd-extra-info')) {
                                        productItem.querySelector('.boost-sd__product-title').after(extraInfo);
                                    }
                                }
                            });
                        }
                        // End-------------------------------------------------------------
                    } catch (e) {
                        console.warn(e);
                    }
                }
            }),
        });
    }
}
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItemGrid]);
const formatMoney = (money, format, withoutTrailingZeros) => {
    if (typeof format == 'undefined') format = boostSDAppConfig.shop.money_format;
    if (format == 'money_with_currency') format = boostSDAppConfig.shop.money_format_with_currency;
    if (typeof withoutTrailingZeros == 'undefined') var withoutTrailingZeros = false;
    // if (typeof Shopify.formatMoney === 'function') { return Shopify.formatMoney(money, format); }
    if (typeof money == 'string') {
        money = money.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function defaultOption(opt, def) {
        return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');
        if (isNaN(number) || number == null) {
            return 0;
        }
        number = parseFloat(number).toFixed(precision);
        var parts = number.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var money = parts[1] ? decimal + parts[1] : '';
        return withoutTrailingZeros == true ? (dollars + money).replace(/((\,00)|(\.00))$/g, '') : dollars + money;
    }
    var matches = formatString.match(placeholderRegex);
    var match = matches && matches.length > 1 ? matches[1] : '';
    switch (match) {
        case 'amount':
            value = formatWithDelimiters(money, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(money, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(money, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(money, 0, '.', ',');
            break;
        case 'amount_with_space_separator_no_comma':
            value = formatWithDelimiters(money, 2);
            break;
        case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(money, 0, ' ', '.');
            break;
        default:
            value = formatWithDelimiters(money, 2);
            break;
    }
    formatString = formatString.replace(placeholderRegex, value);
    return formatString;
};
const updateProductItem3 = (componentRegistry) => {
    componentRegistry.useComponentPlugin("ProductItem", {
        name: "Add SKU and specsheet to product card",
        enabled: true,
        apply: () => ({
            afterRender(element) {
                try {
                    let productData =
                        element.getParams()?.props?.product ||
                        element.getParams()?.props?.productData ||
                        element.getParams()?.props?.data;
                    let productItem = document.querySelector('.boost-sd__product-item[data-product-id="' + productData.id + '"]');
                    if (!productItem) return;
                    var activeCountry = Shopify.country;
                    // Use Session Storage
                    if (
                        typeof sessionStorage !== "undefined" &&
                        typeof config[productData.id] !== "undefined" &&
                        typeof config[productData.id][activeCountry] !== "undefined"
                    ) {
                        buildPrice(config[productData.id][activeCountry], productItem);
                    } else {
                        // Use Ajax
                        // Set link for ajax
                        let productHandleAjax =
                            Shopify.routes.root + "products/" + productData.handle + "?view=boost-sd-custom-integration";
                        let requestReg = formRequest(productHandleAjax);
                        requestReg
                            .then((res_success) => {
                                let parse_res_success = JSON.parse(res_success);
                                // Set dataAjax session storage config
                                let activeCurrencyData = {};
                                activeCurrencyData[activeCountry] = parse_res_success;
                                setConfig(parse_res_success.id, activeCurrencyData);
                                // Render Ajax Data
                                let ajaxProductItem = document.querySelector('.boost-sd__product-item[data-product-id="' + parse_res_success.id + '"]');
                                buildPrice(parse_res_success, ajaxProductItem);
                            })
                            .catch((res_error) => {
                                console.error(res_error);
                            });
                    }
                } catch (e) {}
            },
        }),
    });
    componentRegistry.useComponentPlugin("QuickView", {
        name: "Modify Quickview Option Background",
        enabled: true,
        apply: () => ({
            afterRender(element) {
                let productData =
                    element.getParams()?.props?.productData ||
                    element.getParams()?.props?.product ||
                    element.getParams()?.props?.data; // Get product data
                if (typeof productData === "undefined") return;
                // Loop all option to add custom class
                let priceEls = document.querySelector('.boost-sd__quick-view[product-id="' + productData.id + '"]');
                if (!priceEls) return;
                var activeCountry = Shopify.country;
                // Use Session Storage
                if (
                    typeof sessionStorage !== "undefined" &&
                    typeof config[productData.id] !== "undefined" &&
                    typeof config[productData.id][activeCountry] !== "undefined"
                ) {
                    buildQuickViewPrice(config[productData.id][activeCountry], priceEls);
                } else {
                    // Use Ajax
                    // Set link for ajax
                    let productHandleAjax =
                        Shopify.routes.root + "products/" + productData.handle + "?view=boost-sd-custom-integration";
                    let requestReg = formRequest(productHandleAjax);
                    requestReg
                        .then((res_success) => {
                            let parse_res_success = JSON.parse(res_success);
                            // Render Ajax Data
                            let ajaxProductItem = document.querySelector(
                                '.boost-sd__quick-view[product-id="' + parse_res_success.id + '"]',
                            );
                            buildQuickViewPrice(parse_res_success, ajaxProductItem);
                        })
                        .catch((res_error) => {
                            console.error(res_error);
                        });
                }
                // Reupdate if change an option
            },
        }),
    });
};
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([updateProductItem3]);
// Build Price
function buildPrice(data, productItem) {
    let onSale = data.compare_at_price_min > data.price_min;
    let varieties = data.price_max > data.price_min;
    let soldOut = !data.available;
    const comparision = data.price_min == data.compare_at_price_min;
    productItem.querySelector(
        ".boost-sd__product-price .boost-sd__product-price-wrapper .boost-sd__format-currency:not(.boost-sd__format-currency--price-compare) span",
    ).innerHTML = formatMoney(data.price_min, 'money_with_currency');
    if (comparision) {
        productItem.querySelector('.boost-sd__format-currency--price-compare').style.display = "none";
        productItem.querySelector(
            ".boost-sd__product-price .boost-sd__product-price-wrapper .boost-sd__format-currency:not(.boost-sd__format-currency--price-compare)",
        ).style.color = '#222';
    }
    if (onSale) {
        if (!productItem.querySelector('.boost-sd__format-currency--price-compare')) {
            const compare_price = `<span class="boost-sd__format-currency boost-sd__format-currency--price-compare" style="color: rgb(142, 141, 139); font-size: 13px;">${formatMoney(data.compare_at_price_min, 'money_with_currency')}</span>`;
            console.log(formatMoney(data.compare_at_price_min, 'money_with_currency'))
            productItem.querySelector('.boost-sd__product-price-wrapper').insertAdjacentHTML('beforeend', compare_price);
            productItem.querySelector('.boost-sd__format-currency>span').style.color = "rgb(186, 70, 58)"
        } else {
            productItem.querySelector(
                ".boost-sd__product-price .boost-sd__product-price-wrapper .boost-sd__format-currency--price-compare span",
            ).innerHTML = formatMoney(data.compare_at_price_min, 'money_with_currency');
        }
    }
}

function buildQuickViewPrice(data, productItem) {
    let onSale = data.compare_at_price_min > data.price_min;
    let varieties = data.price_max > data.price_min;
    let soldOut = !data.available;
    if (onSale) {
        productItem.querySelector(
            ".boost-sd__quick-view-price .boost-sd__format-currency.boost-sd__format-currency--price-sale span",
        ).innerHTML = formatMoney(data.price_min, 'money_with_currency');
        productItem.querySelector(
            ".boost-sd__quick-view-price .boost-sd__format-currency.boost-sd__format-currency--price-compare span",
        ).innerHTML = formatMoney(data.compare_at_price_min, 'money_with_currency');
    } else {
        productItem.querySelector(".boost-sd__quick-view-price .boost-sd__format-currency span").innerHTML = formatMoney(
            data.price_min, 'money_with_currency'
        );
    }
}
// Add session storage config
if (typeof sessionStorage !== "undefined") {
    var CUSTOM_HTML_STORAGE_KEY = "linjerAjaxData";
    var config = JSON.parse(sessionStorage.getItem(CUSTOM_HTML_STORAGE_KEY)) || {};

    function setConfig(key, value) {
        config[key] = value;
        sessionStorage.setItem(CUSTOM_HTML_STORAGE_KEY, JSON.stringify(config));
    }
}

function formRequest(value) {
    return new Promise((resolve, reject) => {
        var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
        xhr.open("GET", value);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.onload = () => resolve(xhr.responseText);
        xhr.onerror = () => reject(xhr.statusText);
        xhr.send();
    });
}